import { TranslationOptionsParams } from './shared.types';
import { TRANSLATION_EXCLUDE_FROM_TRANSLATION } from './static';

export function translationClasses(params?: TranslationOptionsParams) {
  let className = '';

  className = params?.ExcludeFromTranslation
    ? className + TRANSLATION_EXCLUDE_FROM_TRANSLATION + ' '
    : '';

  return className;
}
